<template>
  <div class="app_wrap">
    <Carousel  :carousel-data="carouselData" ></Carousel>
    <CoreTechMod :core-tech-data="coreTechData"></CoreTechMod>
    <Solution></Solution>
    <NewsCenter :news-data="newsData"></NewsCenter>
    <AboutUs></AboutUs>
  </div>
</template>

<script>
  import Carousel  from '@/views/home/components/Carousel.vue';
  import CoreTechMod from '@/views/home/components/CoreTechMod.vue';
  import Solution from '@/views/home/components/Solution.vue';
  import NewsCenter from '@/views/home/components/NewsCenter.vue';
  import AboutUs from '@/views/home/components/AboutUs.vue'
  import techDetailData from '@/data/techDetailData';
  import { homeCarouselData } from '@/data/homeData';
  import { getRecommendNewsListApi, getLatestNewsListApi } from '@/API/news';
  
  export default {
    name: "Home",
    components: { Carousel, CoreTechMod, Solution, NewsCenter, AboutUs },
    data() {
      return {
        carouselData: homeCarouselData,
        coreTechData: techDetailData.filter(item => item.display !== false),
        newsData: []
      }
    },
    async mounted() {
      await this.fetchNewsData();
    },
    methods: {
      async fetchNewsData() {
        try {
          // 获取前两个推荐新闻
          const recommendRes = await getRecommendNewsListApi({ limit: 2 });
          const recommendNews = recommendRes.data || [];
          
          // 获取一个最新新闻
          const latestRes = await getLatestNewsListApi({ limit: 1 });
          const latestNews = latestRes.data || [];
          
          // 合并数据，确保格式正确
          this.newsData = [
            ...recommendNews.map(item => ({
              id: item.articleId || item.id,
              articleId: item.articleId || item.id,
              img: item.thumbnail || item.imageUrl || item.image,
              title: item.articleTitle || item.title,
              overview: item.subhead || item.summary || item.content,
              url: '',
              artType: item.artType || '0',
              category: item.category || 'enterprise'
            })),
            ...latestNews.map(item => ({
              id: item.articleId || item.id,
              articleId: item.articleId || item.id,
              img: item.thumbnail || item.imageUrl || item.image,
              title: item.articleTitle || item.title,
              overview: item.subhead || item.summary || item.content,
              url: '',
              artType: item.artType || '0',
              category: item.category || 'enterprise'
            }))
          ];
        } catch (error) {
          console.error('获取新闻数据失败:', error);
          this.newsData = [];
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.app_wrap {
  height: 100%;
  width:100%;
}
</style>
